import { Injectable, signal, inject } from '@angular/core';
import { ICampaignDetailModel } from '../../interfaces/campaign.interface';
import { ItemModel } from '../../interfaces/items.interface';
import { BehaviorSubject, Subject } from 'rxjs';
import { CampaignService } from './campaign.service';

@Injectable({
  providedIn: 'root',
})
export class CampaignSignalService {
  private readonly campaignService = inject(CampaignService);
  private readonly _campaignDetail = signal<ICampaignDetailModel | null>(null);
  private $campaignId = signal<number>(0);
  private $searchItemData = signal<ItemModel | null>(null);
  private visibilitySubject = new Subject<boolean>();
  public isVisible$ = this.visibilitySubject.asObservable();
  private isVisible = false;
  private viewSubject = new BehaviorSubject<any>({
    selectedCampaignView: 'Gallery View',
    viewCampaignToggle: false
  });
  view$ = this.viewSubject.asObservable();

  getCampaignDetail() {
    return this._campaignDetail();
  }
  setCampaignDetail(value : ICampaignDetailModel | null) {
    this._campaignDetail.set(value);
  }

  public set signalCampaignId(value) {
    this.$campaignId = value;
  }
  public get signalCampaignId() {
    return this.$campaignId;
  }

  public set searchItemData(value) {
    this.$searchItemData = value;
  }
  public get searchItemData() {
    return this.$searchItemData;
  }

  toggle() {
    this.isVisible = !this.isVisible;
    this.visibilitySubject.next(this.isVisible);
  }
  
  show() {
    this.isVisible = true;
    this.visibilitySubject.next(this.isVisible);
  }

  updateView(data: any) {
    this.viewSubject.next(data);
  }

  // Add a refresh trigger for campaign data
  private refreshTrigger = new Subject<void>();
  public refresh$ = this.refreshTrigger.asObservable();

  triggerRefresh() {
    this.refreshTrigger.next();
    // Also refresh campaign details to get updated linkedItemStops
    this.refreshCampaignDetails();
  }

  refreshCampaignDetails() {
    const currentCampaignId = this.$campaignId();
    if (currentCampaignId > 0) {
      this.campaignService.getCampaignById(currentCampaignId).subscribe({
        next: (campaignDetails) => {
          if (campaignDetails) {
            this.setCampaignDetail(campaignDetails);
          }
        },
        error: (error) => {
          console.error('Error refreshing campaign details:', error);
        }
      });
    }
  }
}
